module.exports = __webpack_public_path__ + "static/media/lu.4e06269e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/lu.svg
// module id = 179
// module chunks = 0